import styled from 'styled-components'

export const Button = styled.button`
	background-color: var(--Branding-Red);
	color: var(--Branding-Text-White);
	border: none;
	border-radius: 4px;
	padding: 8px 12px;
`
